import { Component, Inject, OnInit } from '@angular/core';
import { TableDescriptor } from '../../components/kiene-table/table-descriptor';
import { MatDialog } from '@angular/material/dialog';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { Condition, Operator, TableOption } from '../../components/kiene-table/table-option';
import { Router } from '@angular/router';
import {
    DateTableColumn,
    KieneBooleanTableColumn,
    PdfTableColumn,
    StatusTableColumn,
    TableColumn,
} from '../../components/kiene-table/table-column';
import { ConfirmDialogComponent } from '../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog.component';
import {
    ConfirmDialogInput,
    ConfirmDialogResult,
} from '../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog';
import { LocalStorageService } from '../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import {
    FilterItem,
    FilterItemType,
} from '../../../../projects/kiene-core/src/lib/services/backend-api/classes/filter-item';
import {
    PdfViewerDesktopService,
    PdfViewerDialogInput,
} from '../../../../projects/kiene-core/src/lib/components/pdf-viewer/kiene-pdf-viewer/kiene-pdf-viewer-desktop/pdf-viewer-desktop.service';
import { HttpParams } from '@angular/common/http';

@Component({
    selector: 'kiene-evaluationsbogen-schwein-uebersicht',
    templateUrl: './evaluationsbogen-schwein-uebersicht.component.html',
    styleUrls: ['./evaluationsbogen-schwein-uebersicht.component.scss'],
})
export class EvaluationsbogenSchweinUebersichtComponent implements OnInit {
    tableDescriptor: TableDescriptor = new TableDescriptor();

    constructor(
        public dialog: MatDialog,
        private readonly messageService: MessageService,
        private readonly api: KieneTableService,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly router: Router,
        private readonly localStorageService: LocalStorageService,
        private readonly pdf: PdfViewerDesktopService,
    ) {}

    ngOnInit() {
        this.tableDescriptor.headline = 'Evaluationsbögen Schwein';
        this.tableDescriptor.uniqueIdentifier = 'Evaluationsboegen Schwein';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'evaluationsbogen_schwein/';
        this.tableDescriptor.route = '/belege/evaluationsbogen-schwein/';
        this.tableDescriptor.nameOfIdField = 'eb_id';
        this.tableDescriptor.searchPlaceholder = 'Evaluationsbögen durchsuchen';
        this.tableDescriptor.initialSortColumn = 'eb_id';
        this.tableDescriptor.initialSortDirection = 'desc';
        this.tableDescriptor.sendCurrentClient = true;
        this.tableDescriptor.createAllowed = false;
        this.tableDescriptor.standardCreate = false;
        this.tableDescriptor.showDetailsVoid = this.gotoDetails.bind(this);

        this.tableDescriptor.columns.push(new TableColumn('eb_id', 'ID'));
        this.tableDescriptor.columns.push(new TableColumn('evaluations_jahr', 'Jahr'));
        this.tableDescriptor.columns.push(new TableColumn('vorgaenger_bs_id', 'BSP-ID'));
        this.tableDescriptor.columns.push(new TableColumn('vvvo', 'Kunde VVVO'));
        this.tableDescriptor.columns.push(new TableColumn('kunde', 'Kunde'));
        this.tableDescriptor.columns.push(new TableColumn('tierarzt', 'Tierarzt'));

        const valueColorMap = new Map<number, string>();
        valueColorMap.set(231, '#ff9100');
        valueColorMap.set(232, '#198f13');
        valueColorMap.set(250, '#03a5fc');
        valueColorMap.set(251, '#9c27b0');
        this.tableDescriptor.columns.push(new StatusTableColumn('status', 'Status', valueColorMap));
        this.tableDescriptor.columns.push(new PdfTableColumn('pdf_id', 'PDF', this.showPdf.bind(this)));
        this.tableDescriptor.columns.push(new KieneBooleanTableColumn('unterschrift_kunde', 'Unterschrieben'));
        this.tableDescriptor.columns.push(new DateTableColumn('editiert', 'Editiert am'));
        this.tableDescriptor.columns.push(new TableColumn('editiert_von', 'Editiert von'));

        this.tableDescriptor.options.push(
            new TableOption(this.reopen.bind(this), 'wieder öffnen', 'lock_reset', 11003, {
                conditions: [new Condition('status_id', Operator.GLEICH, 232)],
            }),
        );
        this.tableDescriptor.options.push(
            new TableOption(this.deletePlan.bind(this), 'löschen', 'delete', 11003, {
                conditions: [new Condition('status_id', Operator.GLEICH, 231)],
            }),
        );
        this.tableDescriptor.options.push(
            new TableOption(this.beantragt.bind(this), 'TSK beantragt', 'check', 11006, {
                conditions: [new Condition('status_id', Operator.GLEICH, 232)],
            }),
        );
        this.tableDescriptor.options.push(
            new TableOption(this.nichtBeantragt.bind(this), 'TSK nicht beantragt', 'undo', 11006, {
                conditions: [new Condition('status_id', Operator.GLEICH, 250)],
            }),
        );
        this.tableDescriptor.options.push(
            new TableOption(this.bezahlt.bind(this), 'TSK bezahlt', 'check_circle', 11006, {
                conditions: [new Condition('status_id', Operator.GLEICH, 250)],
            }),
        );

        this.tableDescriptor.permissionView = 11000;

        this.tableDescriptor.filterItems.push(
            new FilterItem('Status: erstellt', 231, FilterItemType.CHECKBOX, 'status_id', true),
        );
        this.tableDescriptor.filterItems.push(
            new FilterItem('Status: abgeschlossen', 232, FilterItemType.CHECKBOX, 'status_id', true),
        );
        this.tableDescriptor.filterItems.push(
            new FilterItem('Status: TSK beantragt', 250, FilterItemType.CHECKBOX, 'status_id', true),
        );
        this.tableDescriptor.filterItems.push(
            new FilterItem('Status: TSK bezahlt', 251, FilterItemType.CHECKBOX, 'status_id', true),
        );
    }

    gotoDetails(row: any) {
        if (!this.localStorageService.hasPermission(11000) && !this.localStorageService.hasPermission(11002)) {
            this.messageService.hintMessage('Keine Berechtigung zum Öffnen des Evaluationsbogens.');
            return;
        }
        this.router.navigate(['belege/evaluationsbogen-schwein/' + row.eb_id]).then();
    }

    showPdf(row: any) {
        const input = new PdfViewerDialogInput(
            'evaluationsbogen_schwein/read_or_mail_pdf.php',
            new HttpParams().set('eb_id', row?.eb_id?.toString()),
            'Evaluationsbogen ' + row?.eb_id,
            { email: { sende_mail: true, kunde_id: row?.kunde_id } },
        );
        this.pdf.openPdfViewer(input);
    }

    beantragt(row: any) {
        this.statusAendern(row, 250);
    }

    nichtBeantragt(row: any) {
        this.statusAendern(row, 232);
    }

    bezahlt(row: any) {
        this.statusAendern(row, 251);
    }

    private statusAendern(row: any, status_id: number) {
        row.status_id = status_id;
        this.api.updateEntity(this.apiBaseUrl + 'evaluationsbogen_schwein/beantragt.php', row).subscribe({
            next: () => this.api.reload(),
            error: err => {
                this.messageService.errorMessage('Fehler!', err);
                this.api.reload();
            },
        });
    }

    deletePlan(row: any) {
        const input = new ConfirmDialogInput();
        input.headline = 'Evaluationsbogen löschen';
        input.text = 'Möchten Sie den Evaluationsbogen wirklich löschen?';
        input.okButton = 'Löschen';
        this.dialog
            .open(ConfirmDialogComponent, { data: input })
            .afterClosed()
            .subscribe({
                next: (response: ConfirmDialogResult) => {
                    if (response?.ok && response?.confirmed) {
                        this.api
                            .deleteEntity(this.apiBaseUrl + 'evaluationsbogen_schwein/delete.php', row)
                            .subscribe({
                                next: () => this.api.reload(),
                                error: error =>
                                    this.messageService.errorMessage('Fehler beim Löschen', error),
                            });
                    }
                },
            });
    }

    reopen(row: any) {
        const input = new ConfirmDialogInput();
        input.headline = 'Status ändern';
        input.text = 'Soll der Evaluationsbogen wieder zur Bearbeitung freigegeben werden?';
        input.okButton = 'Ja';
        input.cancelButton = 'Abbrechen';
        this.dialog
            .open(ConfirmDialogComponent, { data: input })
            .afterClosed()
            .subscribe({
                next: (response: ConfirmDialogResult) => {
                    if (response?.ok && response?.confirmed) {
                        row.status_id = 231;
                        this.api.post(this.apiBaseUrl + 'evaluationsbogen_schwein/update.php', row).subscribe({
                            next: () => {
                                this.router.navigate(['belege/evaluationsbogen-schwein/' + row.eb_id]).then();
                            },
                            error: error =>
                                this.messageService.errorMessage('Fehler beim Ändern des Status', error),
                        });
                    }
                },
            });
    }
}
